import { parse } from 'valibot';
import useRequest from '@/shared/composables/use-request';
import { profileResponseScheme } from './schemes';

class UserProfile {
	async fetchProfile() {
		try {
			const response = await useRequest().$get('/account/user-profile/');

			if (response.status === 'error') {
				return response;
			}

			return parse(profileResponseScheme, response.data);
		} catch (error) {
			console.error(error);
		}
	}
}

export default new UserProfile();
